import React from "react";
import { Card, CardContainer } from "../../components/Card";
import useSWR from "swr";
import API_ENDPOINTS from "../../apis/endpoints";
import {
    CircularProgress,
    Box,
    Typography,
    useTheme,
    Paper,
} from "@mui/material";
import { PieChart2, BarChart } from "../../components/Charts"; // Import PieChart and BarChart from Charts.jsx

function MoviesMetrics() {
    const theme = useTheme();
    const { data, error } = useSWR(`${API_ENDPOINTS.MOVIES_METRICS}`);

    if (!data) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                }}
            >
                <Typography color="error">
                    Error loading data. Please try again later.
                </Typography>
            </Box>
        );
    }

    // Process data for PieChart (Donut)
    const processedData = data?.overall_collection?.map((i) => ({
        ...i,
        collection: i.collection * 1e7,
    }));
    const seriesData = processedData.map((item) => ({
        value: item.genre,
        ref: "collection",
        name: item.genre,
    }));
    // Process data for BarChart
    const processedLatestData = data?.latest_movies_lifetime_collection?.map(
        (i) => ({ ...i, collection: i.collection * 1e7 })
    );

    return (
        <>
            <CardContainer>
                {/* Use PieChart component */}
                <CardContainer>
                    <PieChart2
                        data={processedData}
                        labelKey="genre"
                        dataKey="collection"
                        title="Overall Earnings"
                    />
                </CardContainer>
                <Card>
                    <Typography
                        variant="contentAccent"
                        sx={{
                            color: theme.palette.neutral[500],
                            // marginBottom: "20px",
                        }}
                    >
                        Upcoming Movies
                    </Typography>
                    <div
                        // elevation={3}
                        style={{
                            // width: "80%",
                            maxHeight: "32vh",
                            overflowY: "scroll",
                            padding: 2,
                            margin: "20px auto",

                            // backgroundColor: "#f9f9f9",
                        }}
                    >
                        {data?.upcoming_movies?.map((movie) => (
                            <Box
                                key={movie.id}
                                sx={{
                                    display: "flex",

                                    paddingBottom: 2,
                                }}
                            >
                                {/* Movie Poster */}
                                <Box
                                    component="img"
                                    src={movie.poster}
                                    alt={movie.movie_name}
                                    sx={{
                                        width: "4rem",
                                        // height: "2rem",
                                        aspectRatio: "1/1",
                                        objectFit: "cover",
                                        borderRadius: "4px",
                                        marginRight: 2,
                                        // marginTop: 3,
                                    }}
                                />

                                {/* Movie Details */}
                                <Box>
                                    <Typography
                                        variant="captionRegular"
                                        gutterBottom
                                    >
                                        {movie.movie_name}
                                    </Typography>
                                    <br />
                                    <Typography
                                        variant="supportRegular"
                                        color="textSecondary"
                                        gutterBottom
                                    >
                                        Releasing on: {movie.release_date} |{" "}
                                    </Typography>
                                    <Typography
                                        variant="supportRegular"
                                        color="textSecondary"
                                        gutterBottom
                                    >
                                        Producer: {movie.producers || "N/A"} |{" "}
                                        Director: {movie.directors || "N/A"} |{" "}
                                        Writer: {movie.lyricists || "N/A"} |{" "}
                                    </Typography>
                                    <Typography
                                        variant="supportRegular"
                                        color="textSecondary"
                                        gutterBottom
                                    >
                                        Genres: {movie.genres || "N/A"} |
                                        Banners: {movie.banners || "N/A"}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </div>
                </Card>
            </CardContainer>
            <CardContainer>
                <BarChart
                    data={processedLatestData}
                    series={[
                        {
                            key: "collection",
                            name: "Lifetime Collection",
                        },
                    ]}
                    xKey="movie_name"
                    title="Latest Released Movies & Earnings"
                    isCategoryX
                />
                <div
                    style={{
                        display: "flex",
                        width: "40%",
                        justifyContent: "space-between",
                    }}
                >
                    <PieChart2
                        data={data?.top_lifetime_collection?.map((i) => ({
                            ...i,
                            collection: i.collection * 1e7,
                        }))}
                        labelKey="movie_name"
                        dataKey="collection"
                        title="Top 5 Earning Movies"
                    />
                </div>
            </CardContainer>
            <CardContainer>
                <BarChart
                    data={data?.top_genres_lifetime_collection?.map((i) => ({
                        ...i,
                        collection: i.collection * 1e7,
                    }))}
                    series={[
                        {
                            key: "collection",
                            name: "Lifetime Collection",
                        },
                    ]}
                    xKey="genre"
                    title="Top 5 Genres & Earnings"
                    isCategoryX
                />
                <BarChart
                    data={data?.top_producers_lifetime_collection?.map((i) => ({
                        ...i,
                        collection: i.collection * 1e7,
                    }))}
                    series={[
                        {
                            key: "collection",
                            name: "Lifetime Collection",
                        },
                    ]}
                    xKey="producers"
                    title="Top 5 Producers & Earnings"
                    isCategoryX
                />
            </CardContainer>
        </>
    );
}

export default MoviesMetrics;
